import React, { useMemo } from 'react';
import { Form } from 'react-bootstrap';
import './MultipleChoiceQuestion.css';

/**
 * True/False Question Component
 */
export function TrueFalseQuestion({ question, value, onChange, disabled = false, showCorrect = false }) {
  // Allow providing explicit options, else default to True/False
  const options = useMemo(() => {
    return question?.options && question.options.length === 2
      ? question.options
      : ['True', 'False'];
  }, [question?.id, question?.options]);

  const handleOptionClick = (option) => {
    if (!disabled) {
      onChange(option);
    }
  };

  const normalize = (v) => String(v).toLowerCase();

  return (
    <div className="true-false-question">
      {options.map((option, index) => {
        const isSelected = value === option;
        const isCorrect = normalize(option) === normalize(question.correctAnswer);

        let variantClass = '';
        if (showCorrect) {
          if (isCorrect) {
            variantClass = 'option-correct';
          } else if (isSelected && !isCorrect) {
            variantClass = 'option-incorrect';
          }
        }

        return (
          <div
            key={index}
            className={`option-card ${isSelected ? 'selected' : ''} ${variantClass} ${disabled ? 'disabled' : ''}`}
            onClick={() => handleOptionClick(option)}
            role="button"
            tabIndex={disabled ? -1 : 0}
            onKeyPress={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleOptionClick(option);
              }
            }}
          >
            <Form.Check
              type="radio"
              id={`tf-option-${question.id}-${index}`}
              name={`question-${question.id}`}
              checked={isSelected}
              onChange={() => {}}
              disabled={disabled}
              className="option-radio"
              tabIndex={-1}
            />
            <label 
              htmlFor={`tf-option-${question.id}-${index}`}
              className="option-label"
              onClick={(e) => e.preventDefault()}
            >
              {option}
            </label>
          </div>
        );
      })}
    </div>
  );
}
